var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCafBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "370px",
    height: "208px",
    viewBox: "0 0 370 208",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CAF-assistancetile-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFD7-Iteration-9/07/21-career-edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "personalised-assistance-box-old-tiles",
    transform: "translate(-796.000000, -182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CAF-assistancetile-3",
    transform: "translate(796.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F4F7F9",
    x: 0,
    y: 0,
    width: 370,
    height: 208
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(149.000000, 69.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Brand/48px/Business",
    transform: "translate(0.000000, 4.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.93,63 L5.07,63 C2.27333557,62.9917623 0.00823765128,60.7266644 0,57.93 L0,40.5 L3,40.5 L3,57.93 C3.01612276,59.0664842 3.93351582,59.9838772 5.07,60 L66.93,60 C68.0664842,59.9838772 68.9838772,59.0664842 69,57.93 L69,38.895 L72,38.895 L72,57.93 C71.9917623,60.7266644 69.7266644,62.9917623 66.93,63 Z",
    id: "Path",
    fill: "#002664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.93,15 L5.07,15 C2.27333557,15.0082377 0.00823765128,17.2733356 0,20.07 L0,34.245 C0,35.0734271 0.671572875,35.745 1.5,35.745 L70.5,35.745 C71.3284271,35.745 72,35.0734271 72,34.245 L72,20.07 C71.9917623,17.2733356 69.7266644,15.0082377 66.93,15 Z M69,33 L3,33 L3,20.07 C3.01612276,18.9335158 3.93351582,18.0161228 5.07,18 L66.93,18 C68.0664842,18.0161228 68.9838772,18.9335158 69,20.07 L69,33 Z",
    id: "Shape",
    fill: "#002664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.15,12.21 L51.15,12.21 L51.15,6.81 C51.15,4.7057951 49.4442049,3 47.34,3 L24.66,3 C22.5557951,3 20.85,4.7057951 20.85,6.81 L20.85,12.21 L17.85,12.21 L17.85,6.81 C17.8582495,3.05236322 20.9023632,0.00824950682 24.66,0 L47.34,0 C51.0976368,0.00824950682 54.1417505,3.05236322 54.15,6.81 L54.15,12.21 Z",
    id: "Path",
    fill: "#002664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,41.265 C31.8578644,41.265 28.5,37.9071356 28.5,33.765 C28.5,29.6228644 31.8578644,26.265 36,26.265 C40.1421356,26.265 43.5,29.6228644 43.5,33.765 C43.5,37.9071356 40.1421356,41.265 36,41.265 L36,41.265 Z",
    id: "Path",
    fill: "#D7153A"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafBusiness);
export default __webpack_public_path__ + "static/media/CAF-business.e593bcd76bc7a67aea632f0ae56e3ece.svg";
export { ForwardRef as ReactComponent };